<template>
    <div class="container">
        <div class="icon-header-container">
            <figure class="icon-page-header">
                <img src="/wp-content/uploads/2018/10/page-icon.png" alt="">
            </figure>
            <h1 class="principal-page-title principal-page-title-account">Mis facturas</h1>
        </div>
        <h2 class="subtitle">Rastrea tus paquetes en tiempo real</h2>
        <div class="form-row packages-form bills-form flex-row">
            <div class="form-group">
                <label>Fecha inicial: </label>
                <datepicker  v-model="startDate" format="dd-MM-yyyy" :language="es"></datepicker >
            </div>
            <div class="form-group">
                <label>Fecha final: </label>
                <datepicker  v-model="endDate" format="dd-MM-yyyy" :language="es"></datepicker >
            </div>
            <div class="form-group">
                <label class="hidden-label" for="">Buscar facturas</label>
                <input type="button" value="Buscar Facturas" class="btn btn-success" id="buscar-paquetes" name="buscar-paquetes" v-on:click="searchBills">
            </div>
        </div>
           
        <vue-good-table
            ref="billTable"
            :columns="columns"
            :rows="bills"
            :pagination-options="{
                enabled: true,
                perPageDropdown: [10, 25, 50,100],
                dropdownAllowAll: false,
                nextLabel: 'siguiente',
                prevLabel: 'anterior',
                rowsPerPageLabel: 'Facturas por página',
                ofLabel: 'de',
                pageLabel: 'Página'
            }"
            :sort-options="{
                enabled: true,
                initialSortBy: {field: 'Factura.factura', type: 'desc'}
            }"
            :search-options="{
                enabled: true,
                placeholder: 'Filtrar resultados',
            }"
        styleClass="vgt-table striped">
        <div slot="emptystate">
        No se encontraron facturas
        </div>
        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'Recibos'">
                <p v-for="recibo in props.row.Recibos" :key="recibo.number">
                {{recibo.number}}
                </p>
            </span>
            <span v-else>
                {{props.formattedRow[props.column.field]}}
            </span>
        </template>
        </vue-good-table>      
    </div>
</template>

<script>
import * as CrboxApi from '../services/CrboxApi.js'
import format from 'date-fns/format'
import subMonths from 'date-fns/sub_months'
import Datepicker from 'vuejs-datepicker'
import {es} from 'vuejs-datepicker/dist/locale'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'

export default {
    context: "bills context",
    name:"bills",
    data: () => {
        return {
            user: {},
            startDate: "",
            endDate: "",
            bills: [],
            columns: [],
            es: es
        }
    },
    components: {
        Datepicker,
        VueGoodTable
    },
    mounted(){
        this.columns = this.getColumns()
        this.startDate = subMonths(Date.now(),1)
        this.endDate = Date.now()
        var startDate = format(this.startDate,"DD-MM-YYYY")
        var endDate = format(this.endDate,"DD-MM-YYYY")
        if(this.$auth.user().email){            
            this.getBills(this.$auth.user().email,startDate,endDate)
        }
    },
    methods: {
        searchBills: function(){
            var startDate = format(this.startDate,"DD-MM-YYYY")
            var endDate = format(this.endDate,"DD-MM-YYYY")
            this.getBills(this.$auth.user().email,startDate,endDate)
        },
        getBills: function(email,startDate,endDate){
            let loader = this.$loading.show({
                  container: this.$refs.billTable.$el
            });
            CrboxApi.getBills(this,email,startDate,endDate)
            .then((response) => {
                this.bills = response.data;
                loader.hide()
             })
        },
        getColumns: function(){
            return [
                {
                label: 'Factura',
                field: 'Factura.factura'
                },
                {
                label: 'Guia Master',
                field: 'Factura.masterAirShipment.masterairshipmentnumber'
                },
                {
                label: 'Recibo',
                field: 'Recibos',
                },
                {
                label: 'Descuento aplicado',
                field: 'Factura.descuentoCorporativo._nombre',
                },
                {
                label: 'Bultos',
                field: 'Factura.cantidadBultos',
                },
                {
                label: 'Peso',
                field: 'Factura.weigth',
                },
                {
                label: 'Total',
                field: 'Factura.total',
                }
            ]
        }
    }
}

</script>